import { ref } from "vue";

export const openLogin = ref({
    open: false,
    register: false,
    registerSuccess: false,
});